import { type WorkspacePlanningSettings } from 'app-shared/types';
import {
  getWorkspaceDayHalfDayFromTimestamp,
  isDefined,
} from 'app-shared/utils';
import { Temporal } from 'temporal-polyfill';
import { type InterventionFormValues } from '@/intervention/types/InterventionFormValues';
import { type InterventionFieldsFragment } from '~/generated/graphql';
export const getInterventionFormValues = (
  intervention: InterventionFieldsFragment | undefined,
  settings: WorkspacePlanningSettings,
): InterventionFormValues => {
  const start = isDefined(intervention?.startsAt)
    ? getWorkspaceDayHalfDayFromTimestamp(intervention.startsAt, settings)
    : null;
  const end = isDefined(intervention?.endsAt)
    ? getWorkspaceDayHalfDayFromTimestamp(
        Temporal.Instant.from(intervention.endsAt)
          .subtract({ nanoseconds: 1 })
          .toString(),
        settings,
      )
    : null;
  const dayOf = (timestamp: string | null | undefined) =>
    isDefined(timestamp)
      ? Temporal.Instant.from(timestamp)
          .toZonedDateTimeISO(settings.timeZone)
          .toPlainDate()
          .toString()
      : '';
  return {
    title: intervention?.title ?? '',
    interventionTypeId: intervention?.interventionTypeId ?? '',
    clientName: intervention?.clientName ?? '',
    clientPhone: intervention?.clientPhone ?? '',
    address: intervention?.address ?? '',
    priority: intervention?.priority ?? 'normal',
    status: intervention?.status ?? 'toPlan',
    estimatedDurationMinutes: intervention?.estimatedDurationMinutes ?? null,
    notes: intervention?.notes ?? '',
    collaboratorIds:
      intervention?.assignments.map(
        (assignment) => assignment.collaboratorId,
      ) ?? [],
    skillIds: intervention?.skillIds ?? [],
    startDay: start?.day ?? dayOf(intervention?.startsAt),
    startHalfDay: start?.halfDay ?? 'morning',
    endDay: end?.day ?? dayOf(intervention?.endsAt),
    endHalfDay: end?.halfDay ?? 'afternoon',
  };
};
